import { ComponentProps, useState } from 'react'

import { SelfServicePageDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { LandingPage } from './LandingPage'
import PayrollWizard from './PayrollWizard'

const SelfServicePage = () => {
  const [showWizardModal, setShowWizardModal] = useState<boolean>(false)

  const { data, loading } = useQuery(SelfServicePageDocument)
  const hasManagePayrollPolicies = data?.payroll._policies.managePayrollPolicies.can

  const actions: ComponentProps<typeof ResponsivePage.Body>['transactionalActions'] =
    hasManagePayrollPolicies
      ? {
          primary: {
            label: i18n.t('payroll_bundle.onboarding.welcome_step.cta_button'),
            onClick: () => {
              setShowWizardModal(true)
            },
          },
        }
      : undefined

  return (
    <ResponsivePage.Body
      showHeader={false}
      transactionalActions={actions}
      loading={loading}
      error={undefined}
    >
      <LandingPage />
      {showWizardModal && <PayrollWizard onClose={() => setShowWizardModal(false)} />}
    </ResponsivePage.Body>
  )
}

export default observer(SelfServicePage)
